import { useQuery } from '@tanstack/react-query';

import { ErroApi, apiGet, obterCsrf } from './cliente';

export interface Usuario {
  email: string;
  nome: string;
  is_staff: boolean;
  is_superuser: boolean;
}

/** Usuário logado; `null` se não houver sessão (401). */
export function useUsuario() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async (): Promise<Usuario | null> => {
      try {
        return await apiGet<Usuario>('/me');
      } catch (erro) {
        if (erro instanceof ErroApi && erro.status === 401) return null;
        throw erro;
      }
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

/**
 * O allauth exige POST com CSRF para iniciar o login social e para o logout. Um
 * formulário de verdade (não fetch) é necessário porque o login redireciona para o
 * Google.
 */
async function enviarFormulario(acao: string): Promise<void> {
  const token = await obterCsrf();
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = acao;
  const campo = document.createElement('input');
  campo.type = 'hidden';
  campo.name = 'csrfmiddlewaretoken';
  campo.value = token;
  form.appendChild(campo);
  document.body.appendChild(form);
  form.submit();
}

export function entrarComGoogle(proximo: string = '/'): Promise<void> {
  return enviarFormulario(`/accounts/google/login/?next=${encodeURIComponent(proximo)}`);
}

export function sair(): Promise<void> {
  return enviarFormulario('/accounts/logout/');
}
